import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1e8288e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lg:flex-start ml-4 hidden items-center gap-2 text-sm lg:flex lg:grow lg:text-lg" }
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
const _hoisted_3 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_4 = { class: "absolute -left-9 top-11 z-10 mt-1 w-36 rounded-md bg-white shadow shadow-gray-500 transition ease-in md:w-48 lg:w-52" }
const _hoisted_5 = { class: "flex flex-col rounded-md px-4 pb-3 pt-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import {
  ChevronDownIcon,
} from '@heroicons/vue/24/outline';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import FullPageButton from '@/components/Helper/FullPageButton.vue';
import {
  CONSTANTS,
} from '@/helpers';
import {
  useStore,
} from '@/store';
import type {
  INav,
} from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopHeaderMenu',
  props: {
    isDynamicPageNonMobileOpen: { type: Boolean },
    availableNavs: {}
  },
  emits: ["click:nav", "update:dpNonMobileOpen"],
  setup(__props: any, { emit: emits }) {

const props = __props;






const backendStore = useStore.backend;
const { features } = backendStore.clientCompany.subscriptionSettings;

const router = useRouter();
const route = useRoute();

function onDynamicPageDropdownNonMobileClick(slug: string): void {
  emits('update:dpNonMobileOpen', !props.isDynamicPageNonMobileOpen);

  const targetRoute = `${CONSTANTS.ROUTE.dynamicPages.path}/${slug}`;

  router.push(targetRoute);
}

function getSelectedNav(path: string): boolean {
  const dynamicPagePath = CONSTANTS.ROUTE.dynamicPages.path;
  const isDynamicPage = route.fullPath.startsWith(dynamicPagePath);

  if (isDynamicPage) {
    return path.startsWith(dynamicPagePath);
  }

  return route.path === path;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableNavs, (nav, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `${index}_${nav}`
      }, [
        (_unref(backendStore).dynamicPages.length
          && (nav.alternateTitle === _unref(CONSTANTS).ROUTE.dynamicPages.alternateTitle)
          && _unref(features).dynamicPageManagement
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["inline-flex items-center gap-2 rounded-lg p-2.5 text-sm hover:bg-[#A3D4F2]/[22%] md:text-base lg:text-lg", [
            { 'bg-[#A3D4F2]/[22%]': _ctx.isDynamicPageNonMobileOpen },
            getSelectedNav(nav.path)
              ? 'font-semibold text-dynamicSelectedText'
              : 'text-dynamicText',
          ]]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:dpNonMobileOpen', !_ctx.isDynamicPageNonMobileOpen)))
              }, [
                _createElementVNode("p", null, _toDisplayString(nav.alternateTitle), 1),
                _createVNode(_unref(ChevronDownIcon), {
                  class: _normalizeClass(["size-6", {
              'rotate-180 transition ease-in': _ctx.isDynamicPageNonMobileOpen,
              'transition ease-in': !_ctx.isDynamicPageNonMobileOpen,
            }])
                }, null, 8, ["class"])
              ], 2),
              (_ctx.isDynamicPageNonMobileOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_ctx.isDynamicPageNonMobileOpen)
                      ? (_openBlock(), _createBlock(FullPageButton, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('update:dpNonMobileOpen', false)))
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_Transition, {
                      class: "absolute",
                      name: "slide-down"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(backendStore).dynamicPages, (page) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: page._id,
                                type: "button",
                                class: "dynamic-page-option-btn",
                                onClick: ($event: any) => (onDynamicPageDropdownNonMobileClick(page.slug))
                              }, [
                                _createElementVNode("p", {
                                  class: _normalizeClass({
                      'font-bold': _unref(route).fullPath.endsWith(page.slug),
                    })
                                }, _toDisplayString(page.title), 3)
                              ], 8, _hoisted_6))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (nav.alternateTitle !== _unref(CONSTANTS).ROUTE.dynamicPages.alternateTitle)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: _normalizeClass(["flex w-full cursor-pointer items-center p-2.5 hover:rounded-md hover:bg-[#A3D4F2]/[22%]", `${ _unref(route).name === nav.title
          ? 'text-dynamicSelectedText font-semibold' : 'text-dynamicText'}`]),
              onClick: ($event: any) => (emits('click:nav', nav))
            }, [
              _createElementVNode("span", null, _toDisplayString(nav.alternateTitle), 1)
            ], 10, _hoisted_7))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})